import React, { useState } from 'react';

import Table from '~components/molecules/Table';
import Text from '~components/atoms/Text';

import { useAppSelector } from '~redux/hooks';
import { FundTypeEnum, MetalTypeEnum } from '~utils/enums';

import UtilFunctions from '~utils/functions';
import * as Styles from './InventoryReportTable.module.scss';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';
import ActionButton from '~components/atoms/ActionButton';
import InventoryReceivedReportTablePaginator from '../InventoryReceivedReportTablePaginator';
import Image from '~components/atoms/Image';

const InventoryReceivedReportTable = () => {
    const {
        Misc: {
            renderTransactionStatusChip,
            dateTimeFormat,
        },
    } = UtilFunctions; 

    const inventoryReceivedReportListing = useAppSelector(state => state.report.inventoryReport.inventoryReceivedReportTransactionListing.data);

    const isLoading = useAppSelector(state => state.report.loadings.getInventoryReceivedReportTransactionListing);
    const isError = useAppSelector(state => state.report.errors.getInventoryReceivedReportTransactionListing);

    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);
    const [serialNoList, setSerialNoList] = useState<string[]>([]);

    const tableHeader = [
        'IMAGE',
        'PRODUCT NAME',
        'METAL TYPE',
        'BRANCH',
        'RECEIVED FROM',
        'SERIAL NUMBER',
        'QUANTITY',
        'TOTAL WEIGHT (G)',
        'FUND TYPE',
        'RECEIVED AT',
    ];

    const tableBody = inventoryReceivedReportListing.map(transaction => {
        const {
            transferId,
            productName,
            metalType,
            branch,
            receivedFrom,
            serialNumbers,
            quantity,
            totalWeight,
            fundType,
            receivedAt,
            image,
        } = transaction;

        const handleViewSerialNo = () => {
            if (!serialNumbers) return;

            setIsSerialNoModalOpen(true);
            setSerialNoList(serialNumbers);
        };

        const renderSerialNo = () => {
            if (!serialNumbers) return '-';

            return (
                <ActionButton
                    key={transferId}
                    label='View'
                    onClick={handleViewSerialNo}
                />
            );
        };

        return {
            cells: [
                <Image
                    key={transferId}
                    src={image || ''}
                    width={40}
                    height={40}
                />,
                productName,
                MetalTypeEnum[metalType],
                branch?.branchName,
                receivedFrom?.branchName,
                renderSerialNo(),
                quantity,
                totalWeight.toFixed(3),
                FundTypeEnum[fundType],
                receivedAt ? dateTimeFormat(receivedAt) : '-',
            ],
        }
    });

    return (
        <>
            <Table
                header={tableHeader}
                body={tableBody}
                isLoading={isLoading}
                error={isError}
            />

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />

            <InventoryReceivedReportTablePaginator />
        </>
    );
};

export default InventoryReceivedReportTable;
